import { Typography } from 'seagull';
import { formatShortMonthUSDate } from "../../../../utils";
import styles from "./TimeActivityDetails.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TimeActivityDetails = _ref => {
  let {
    timeActivity: {
      id,
      date,
      hours,
      minutes,
      note
    }
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.timeActivityRow,
      children: [/*#__PURE__*/_jsx(Typography, {
        className: styles.timeActivityLabel,
        children: 'Date: '
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": "time-activity-".concat(id, "-date"),
        children: formatShortMonthUSDate(new Date(date))
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.timeActivityRow,
      children: [/*#__PURE__*/_jsx(Typography, {
        className: styles.timeActivityLabel,
        children: 'Duration: '
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": "time-activity-".concat(id, "-duration"),
        children: "".concat(hours, " hrs ").concat(minutes, " mins")
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.timeActivityRow,
      children: [/*#__PURE__*/_jsx(Typography, {
        className: styles.timeActivityLabel,
        children: 'Notes: '
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": "time-activity-".concat(id, "-note"),
        className: styles.notes,
        children: note
      })]
    })]
  });
};